import { render, staticRenderFns } from "./SvgLike.vue?vue&type=template&id=0f40588a&"
import script from "./SvgLike.vue?vue&type=script&lang=js&"
export * from "./SvgLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports